import React from 'react';
import { FieldValidator } from '../config/types';
import { validateField } from '../utils/validators';

const useInputUpdateHelper = <T,>(
  updateForm: React.Dispatch<React.SetStateAction<T>>
) => {
  return (key: keyof T, fieldType?:FieldValidator) => (event: React.ChangeEvent<HTMLInputElement>) => {
    
    updateForm((prev) => ({
      ...prev,
      [key]: {value: event.target.value,...validateField(event.target.value,fieldType)},
    }));
  };
};

export default useInputUpdateHelper


